<template>
  <div :class="'adjust_candidate '+randomClass" v-if="cusParam_configData">
    <div class="top" v-if="!cusParam_simple">
      <div class="title_area">
        <span class="title">候选人调整</span>
        <div class="search_box">
          <i class="kdfont kdfont-f" @click="filterSeaKey = searchKey.trim()"></i>
          <input v-model="searchKey" type="text" placeholder="搜索候选人姓名" @keyup.enter="filterSeaKey = searchKey.trim()">
        </div>
      </div>
      <div class="overview_area">
        <div class="overview_nums">
          <div :class="{'selected':filterAnsState === null}" @click="filterAnsState = null">
            已安排候选人数：{{ cusParam_configData.alreadyArrangeTotalNums }}
          </div>
          <div :class="{'selected':filterAnsState === 'A'}" @click="filterAnsState = 'A'">
            未答复人数：{{ cusParam_configData.noAnswerTotalNums }}
          </div>
          <div :class="{'selected':filterAnsState === 'C'}" @click="filterAnsState = 'C'">
            不参加人数：{{ cusParam_configData.noAttendTotalNums }}
          </div>
        </div>
        <div class="room_switch">
          展示面试间
          <el-switch v-model="flodStatus" :activeColor="'var(--theme-color)'" inactive-color="#c6c6c6"></el-switch>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="date_tab">
        <div class="date_item" :class="{'selected':curSpecialDayIndex === index}"
             v-for="(item,index) in cusParam_configData.specialArrTimeDateList"
             @click="selectSpecialDay(index)">{{ dateFormat('MM月dd日', item) }}
        </div>
      </div>
      <div class="color_tips" v-if="!cusParam_simple">
        <div class="noreply"><span class="noreply_color"></span><span>候选人未答复</span></div>
        <div class="join"><span class="join_color"></span><span>候选人参加</span></div>
        <div class="nojoin"><span class="nojoin_color"></span><span>候选人不参加</span></div>
      </div>
      <div class="table_content" v-if="!cusParam_simple && flodStatus">
        <div class="table_head">
          <span style="width: 20%;text-align: center">场次</span>
          <div style="display: flex;align-items: stretch;position: relative;width: 80%">
            <span style="width: 10%">面试间</span>
            <span style="width: 20%">面试官</span>
            <span style="width: 50%">候选人</span>
            <span style="width: 10%;text-align: center">已安排候选人数</span>
            <span style="width: 10%;text-align: center">最多可安排候选人数</span>
          </div>
        </div>
        <div class="table_body">
          <div class="table_item" v-for="(itemSite,indexSite) in curSiteRoomList">
            <div class="item_sitetime" style="width: 20%">{{ itemSite.specialArrTimeRange }}</div>
            <div class="item_rooms" style="width: 80%">
              <div class="item_roomitem"
                   v-for="(itemRoom,indexRoom) in itemSite.specialArrTimeRoomAndAppfileListEntitys">
                <span class="item_intvroom" style="width: 10%">{{ itemRoom.roomName }}</span>
                <span class="item_intver" style="width: 20%"><span class="master_tip">（主）</span>{{
                    itemRoom.intverNames
                  }}</span>
                <span class="item_candidate" style="width: 50%">
                <DragGroup :dragType="'room'" :curSpecialDayIndex="curSpecialDayIndex" :indexSite="indexSite" :indexRoom="indexRoom"
                           :appfiles.sync="itemRoom.specialArrAppfileList" @siteAppfileOp="siteAppfileOp"
                           :filterAnsState="filterAnsState"
                           :filterSeaKey="filterSeaKey"
                           :cusParam_configData="cusParam_configData"
                           :cusParam_rejectRsn="cusParam_rejectRsn"></DragGroup>
              </span>
                <span class="item_arranged"
                      :class="{'redTip': itemRoom.specialArrAppfileList.length > itemRoom.mostArrangeNums}"
                      style="width: 10%">{{ itemRoom.specialArrAppfileList.length }}</span>
                <span class="item_morearrange" style="width: 10%">{{ itemRoom.mostArrangeNums }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table_content" v-if="!cusParam_simple && !flodStatus">
        <div class="table_head">
          <span style="width: 10%;text-align: center">场次</span>
          <span style="width: 10%">面试间数量</span>
          <span style="width: 60%">候选人</span>
          <span style="width: 10%;text-align: center">已安排候选人数</span>
          <span style="width: 10%;text-align: center">最多可安排候选人数</span>
        </div>
        <div class="table_body">
          <div class="table_item" v-for="(itemSite,indexSite) in curSiteList">
            <span class="item_sitetime" style="width: 10%">{{ itemSite.specialArrTimeRange }}</span>
            <span class="item_intvroom" style="width: 10%">{{ itemSite.roomNums }}</span>
            <span class="item_candidate" style="width: 60%">
            <DragGroup :dragType="'site'" :curSpecialDayIndex="curSpecialDayIndex" :indexSite="indexSite" :appfiles.sync="itemSite.allArrAppfileList"
                       :filterAnsState="filterAnsState"
                       :filterSeaKey="filterSeaKey"
                       @siteAppfileOp="siteAppfileOp" :cusParam_configData="cusParam_configData"
                       :cusParam_rejectRsn="cusParam_rejectRsn"></DragGroup>
          </span>
            <span class="item_arranged"
                  :class="{'redTip': itemSite.allArrAppfileList.length > itemSite.allMostArrangeNums}"
                  style="width: 10%">{{
                itemSite.allArrAppfileList.length
              }}</span>
            <span class="item_morearrange" style="width: 10%">{{ itemSite.allMostArrangeNums }}</span>
          </div>
        </div>
      </div>
      <div class="table_content" v-if="cusParam_simple">
        <div class="table_head">
          <span style="width: 30%;text-align: center">场次</span>
          <div style="display: flex;align-items: stretch;position: relative;width: 70%">
            <span style="width: 50%">面试间</span>
            <span style="width: 50%">面试官</span>
          </div>
        </div>
        <div class="table_body">
          <div class="table_item" v-for="(itemSite,indexSite) in curSiteRoomList">
            <div class="item_sitetime" style="width: 30%">{{ itemSite.specialArrTimeRange }}</div>
            <div class="item_rooms" style="width: 70%">
              <div class="item_roomitem"
                   v-for="(itemRoom,indexRoom) in itemSite.specialArrTimeRoomAndAppfileListEntitys">
                <span class="item_intvroom" style="width: 50%">{{ itemRoom.roomName }}</span>
                <span class="item_intver" style="width: 50%"><span class="master_tip">（主）</span>{{
                    itemRoom.intverNames
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DragGroup from "./DragGroup.vue";

export default {
  components: {
    DragGroup
  },
  props: {
    cusParam_configData: Object,
    cusParam_rejectRsn: Array,
    cusParam_saveAndSendMsg: Number,
    cusParam_save: Number,
    cusParam_simple: Boolean,
    cusParam_verifyUpdate: Number
  },
  computed: {},
  watch: {
    cusParam_configData: function (obj) {
      this.caluOverviewResult();
      this.curSpecialDayIndex = 0;
      this.getCurTableData()
    },
    flodStatus: function (state) {
      if (!state) {
        this.getCurSiteList();
      }
      this.hideScrollBar();
    },
    cusParam_saveAndSendMsg: function (val) {
      if (this.saveVerify()) {
        this.invoke("form_saveAndSendMsg", this.cusParam_configData)
        this.hasUpdateConfig = false;
      }
    },
    cusParam_save: function (val) {
      if (this.saveVerify()) {
        this.invoke("form_save", this.cusParam_configData)
        this.hasUpdateConfig = false
      }
    },
    cusParam_verifyUpdate: function (val) {
      this.invoke("form_isUpdate", this.hasUpdateConfig)
    }
  },
  data() {
    return {
      hasUpdateConfig: false,
      moreArrangeRooms: [],
      searchKey: '',
      flodStatus: false,
      curSpecialDayIndex: 0,
      curSiteRoomList: null,
      curSiteList: null,
      filterAnsState: null, //A未答复  B参加  C不参加
      filterSeaKey: '',
      timer: null,
    }
  },
  mounted() {
    this.hideScrollBar();
  },
  methods: {
    selectSpecialDay(index) {
      this.curSpecialDayIndex = index;
      this.getCurTableData();
    },

    /**
     * 去除滚动条
     */
    hideScrollBar() {
      setTimeout(() => {
        let el = $("."+this.randomClass + " .table_body");
        let scrollWidth = el[0].offsetWidth - el[0].clientWidth;
        el.css("marginRight", "-" + scrollWidth + "px")
      }, 200)
    },

    getCurTableData() {
      let curSiteRoomList = this.cusParam_configData.specialArrTimeRangeListEntities[this.curSpecialDayIndex].specialArrTimeRoomListEntities;
      curSiteRoomList.forEach((item, index) => {
        item.specialArrTimeRoomAndAppfileListEntitys.forEach((itemRoom, indexRoom) => {
          if (!itemRoom.specialArrAppfileList) {
            itemRoom.specialArrAppfileList = [];
          }
        })
      })
      this.curSiteRoomList = curSiteRoomList;
      console.log('site', this.curSiteRoomList)
      this.getCurSiteList();
    },
    getCurSiteList() {
      this.curSiteList = [];
      this.curSiteRoomList.forEach((item, index) => {
        let intergratObj = this.getIntegratDataForSite(item.specialArrTimeRoomAndAppfileListEntitys);
        let obj = {
          "specialArrTimeRange": item.specialArrTimeRange,
          "specialArrTimeDate": item.specialArrTimeDate,
          "roomNums": item.roomNums,
          "allMostArrangeNums": intergratObj.allMostArrangeNums,
          "allArrAppfileList": intergratObj.allArrAppfileList
        }
        this.curSiteList.push(obj);
      })
      console.log(this.curSiteList)
    },
    saveVerify() {
      if (!this.moreArrangeRooms.length) {
        return true;
      } else {
        this.curSpecialDayIndex = this.moreArrangeRooms[0].specialDateIndex;
        this.getCurTableData();
        this.flodStatus = true;
        this.invoke("form_moreArrange", true)
        return false
      }
    },
    getIntegratDataForSite(siteObj) {
      let allMostArrangeNums = 0;
      let allArrAppfileList = [];
      siteObj.forEach((item, index) => {
        allMostArrangeNums += item.mostArrangeNums;
        allArrAppfileList = allArrAppfileList.concat(item.specialArrAppfileList);
      })
      return {
        "allMostArrangeNums": allMostArrangeNums,
        "allArrAppfileList": allArrAppfileList
      }
    },
    siteAppfileOp(params) {
      console.log(params)
      if (params.opType === 'move' && params.dragType === 'site') {
        let appfileObj = this.curSiteList[params.toSiteIndex].allArrAppfileList[params.tositeAppfileIndex];
        appfileObj.hasSendMsg = false;
        appfileObj.applicationanswer = 'A';
        console.log(appfileObj)
        this.deleteAppfileFromSite(params, appfileObj);
        this.addAppfileFromSite(params, appfileObj)
      }
      if (params.opType === 'move' && params.dragType === 'room') {
        this.curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[params.toRoomIndex].isUpdate = true;
        this.curSiteRoomList[params.fromSiteIndex].specialArrTimeRoomAndAppfileListEntitys[params.fromRoomIndex].isUpdate = true;
        if (params.fromSiteIndex !== params.toSiteIndex) {
          let appfileObj = this.curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[params.toRoomIndex].specialArrAppfileList[params.tositeAppfileIndex];
          console.log(appfileObj);
          appfileObj.hasSendMsg = false;
          appfileObj.applicationanswer = 'A';
        }
      }
      if (params.opType === 'delete' && params.dragType === 'site') {
        this.deleteAppfileFromSite(params, params.appfileObj)
      }
      if (params.opType === 'delete' && params.dragType === 'room') {
        this.curSiteRoomList[params.fromSiteIndex].specialArrTimeRoomAndAppfileListEntitys[params.fromRoomIndex].isUpdate = true;
      }
      if (params.opType === 'handmove') {
        this.addAppfileFromDateSite(params);
        this.getCurSiteList();
      }
      if(params.opType === 'updateState'){
        this.updateAppfileState(params);
        this.getCurSiteList();
      }
      this.caluOverviewResult();
      this.autoPutCache();
      console.log(this.curSiteRoomList)
    },
    updateAppfileState(params){
      this.curSiteRoomList[params.fromSiteIndex].specialArrTimeRoomAndAppfileListEntitys.forEach((item, index) => {
        item.specialArrAppfileList.forEach((itemAppfile, indexAppfile) => {
          if (itemAppfile.specialAppfile === params.appfileObj.specialAppfile) {
            item.specialArrAppfileList[indexAppfile] = params.appfileObj;
            item.isUpdate = true;
          }
        })
      })
    },
    deleteAppfileFromSite(params, appfileObj) {
      this.curSiteRoomList[params.fromSiteIndex].specialArrTimeRoomAndAppfileListEntitys.forEach((item, index) => {
        item.specialArrAppfileList.forEach((itemAppfile, indexAppfile) => {
          if (itemAppfile.specialAppfile === appfileObj.specialAppfile) {
            item.specialArrAppfileList.splice(indexAppfile, 1);
            item.isUpdate = true;
            return true;
          }
        })
      })
    },
    addAppfileFromSite(params, appfileObj) {
      let minAppfileNum = null, minAppfileIndex = 0;
      this.curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys.forEach((item, index) => {
        if (minAppfileNum === null || item.specialArrAppfileList.length < minAppfileNum) {
          minAppfileNum = item.specialArrAppfileList.length;
          minAppfileIndex = index;
        }
      })
      this.curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[minAppfileIndex].specialArrAppfileList.push(appfileObj);
      this.curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[minAppfileIndex].isUpdate = true;
    },
    addAppfileFromDateSite(params) {
      let minAppfileNum = null, minAppfileIndex = 0;
      let curSiteRoomList = this.cusParam_configData.specialArrTimeRangeListEntities[params.toDateIndex].specialArrTimeRoomListEntities;
      curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys.forEach((item, index) => {
        if (!item.specialArrAppfileList) {
          item.specialArrAppfileList = [];
        }
        if (minAppfileNum === null || item.specialArrAppfileList.length < minAppfileNum) {
          minAppfileNum = item.specialArrAppfileList.length;
          minAppfileIndex = index;
        }
      })
      curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[minAppfileIndex].specialArrAppfileList.push(params.appfileObj);
      curSiteRoomList[params.toSiteIndex].specialArrTimeRoomAndAppfileListEntitys[minAppfileIndex].isUpdate = true;
    },
    caluOverviewResult() {
      let alreadyArrangeTotalNums = 0, noAnswerTotalNums = 0, noAttendTotalNums = 0, hasUpdateConfig = false,
          moreArrangeRooms = [];
      this.cusParam_configData.specialArrTimeRangeListEntities.forEach((itemDate, indexDate) => {
        itemDate.specialArrTimeRoomListEntities.forEach((itemSite, indexSite) => {
          itemSite.specialArrTimeRoomAndAppfileListEntitys.forEach((itemRoom, indexRoom) => {
            if (itemRoom.isUpdate) {
              hasUpdateConfig = true;
            }
            if (itemRoom.specialArrAppfileList.length > itemRoom.mostArrangeNums) {
              moreArrangeRooms.push({
                specialDateIndex: indexDate
              })
            }
            itemRoom.specialArrAppfileList.forEach((itemAppfile, indexAppfile) => {
              alreadyArrangeTotalNums++;
              if (itemAppfile.applicationanswer === 'A') {
                noAnswerTotalNums++;
              }
              if (itemAppfile.applicationanswer === 'C') {
                noAttendTotalNums++;
              }
            })
          })
        })
      })
      this.cusParam_configData.alreadyArrangeTotalNums = alreadyArrangeTotalNums;
      this.cusParam_configData.noAnswerTotalNums = noAnswerTotalNums;
      this.cusParam_configData.noAttendTotalNums = noAttendTotalNums;
      this.hasUpdateConfig = hasUpdateConfig;
      this.moreArrangeRooms = moreArrangeRooms;
    },
    autoPutCache() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.invoke("form_putCache", this.cusParam_configData)
      }, 3000)
    }
  }
}
</script>
<style lang="less">
.adjust_candidate {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 25px;
  font-size: 12px;
  color: #212121;
  height: 100%;

  .ellipsis {
    overflow-x: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 0;
    flex-shrink: 0;

    .title_area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 44px;

      .title {
        font-size: 16px;
        color: #212121;
      }

      .search_box {
        display: flex;
        color: #b2b2b2;
        height: 25px;
        align-items: center;
        border-bottom: 1px solid #d9d9d9;

        .kdfont-f {
          cursor: pointer;
        }

        input {
          margin-left: 9px;
          border: 0;
        }

        &:hover {
          border-color: var(--theme-color);

          i {
            color: var(--theme-color);
          }
        }

        &:focus {
          border-color: var(--theme-color);

          i {
            color: var(--theme-color);
          }
        }
      }
    }

    .overview_area {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .overview_nums {
        display: flex;
        align-items: center;

        div {
          border: 1px solid rgba(217, 217, 217, 1);
          border-radius: 2px;
          padding: 7px 12px;
          margin-right: 12px;
          cursor: pointer;

          &:hover {
            border-color: var(--theme-color);
          }
        }

        .selected {
          border-color: var(--theme-color);
          position: relative;

          &:before {
            position: absolute;
            content: '';
            right: 0;
            bottom: 0;
            border-right: 6px solid var(--theme-color);
            border-left: 9px solid transparent;
            border-top: 6px solid transparent;
            border-bottom: 7px solid var(--theme-color);
          }
        }
      }

      .room_switch {
        display: flex;
        align-items: center;

        .el-switch {
          margin-left: 8px;
        }
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 12px;
    flex-shrink: 1;
    flex-grow: 1;
    height: 10px;

    .date_tab {
      display: flex;
      border-bottom: 1px solid #e5e5e5;

      .date_item {
        padding: 6px 20px 8px;
        color: #666;
        cursor: pointer;
      }

      .selected {
        color: var(--theme-color);
        border-bottom: 1px solid var(--theme-color);
      }
    }

    .color_tips {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-top: 12px;

      .noreply, .join, .nojoin {
        color: #333;
        margin-left: 24px;
        display: flex;
        align-items: center;
      }

      .noreply_color, .join_color, .nojoin_color {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        border-radius: 2px;
      }

      .noreply_color {
        background: #FAFAFA;
        border: 1px solid #E5E5E5;
      }

      .join_color {
        background: #F2FFF5;
        border: 1px solid #6DD18E;
      }

      .nojoin_color {
        border: 1px solid #fc8555;
        background: #fff8f2;
      }
    }

    .table_content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      border-left: 1px solid #d9d9d9;
      border-top: 1px solid #d9d9d9;
      margin-top: 12px;
      flex-shrink: 1;
      overflow: auto;
      overflow-x: hidden;

      .table_body {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex-shrink: 1;
        overflow: auto;
      }

      .table_head {
        display: flex;
        flex-shrink: 0;
        flex-grow: 0;
        position: relative;
        height: 35px;
        line-height: 35px;
        background: #f2f2f2;

        span {
          padding: 0 7px;
          border-right: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
          overflow-x: hidden;
          overflow-y: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .table_item {
        display: flex;
        align-items: stretch;
        position: relative;

        .item_sitetime {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .item_sitetime, .item_intvroom, .item_intver, .item_candidate, .item_arranged, .item_morearrange {
          display: flex;
          align-items: center;
          padding: 10px 8px;
          border-right: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
        }

        .item_intver {
          .master_tip {
            color: var(--theme-color);
          }
        }

        .redTip {
          color: #FB2323;
        }

        .item_arranged {
          justify-content: center;
        }

        .item_morearrange {
          justify-content: center;
        }

        .item_candidate {
          flex-grow: 1;
          flex-shrink: 1;
          padding-bottom: 0;
          min-height: 61px;
          display: flex;
          align-items: stretch;
        }


        .item_rooms {
          display: flex;
          flex-direction: column;
          align-items: stretch;

          .item_roomitem {
            display: flex;
            align-items: stretch;
            position: relative;

          }
        }
      }
    }
  }
}
</style>